import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';

interface Props {
  $dark?: boolean;
  $hasNoOffset?: boolean;
  $isRelative?: boolean;
  $isSmall?: boolean;
  $isFixed?: boolean;
}

function getLoadingColour({ $dark = false }: Props) {
  return $dark ? Colours.white : Colours.greenLight2;
}

function isRelativeStyle({ $isRelative = false }: Props) {
  if ($isRelative) {
    return css`
      position: relative;
      top: auto;
      left: auto;
    `;
  }
}

function isSmallStyle({ $isSmall = false }: Props) {
  if ($isSmall) {
    return css`
      height: 26px;
      width: 26px;
      margin-left: -13px;
      margin-top: -13px;

      div {
        width: 20px;
        height: 20px;
        margin: 0;
        border-width: 2px;
      }
    `;
  }
}

function hasNoOffsetStyle({ $hasNoOffset = false }: Props) {
  if ($hasNoOffset) {
    return css`
      margin-left: 0;
      margin-top: 0;
    `;
  }
}

function isFixedStyle({ $isFixed = false }: Props) {
  if ($isFixed) {
    return css`
      position: fixed;
    `;
  }
}

export default styled.div<Props>`
  position: absolute;
  top: 50%;
  left: 50%;
  height: 64px;
  width: 64px;
  margin-left: -32px;
  margin-top: -32px;
  animation: lds-outer 1.2s ease-in-out infinite;
  z-index: 100;

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 51px;
    height: 51px;
    margin: 6px;
    border: 3px solid ${getLoadingColour};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${getLoadingColour} transparent transparent transparent;
  }

  div:nth-child(1) {
    animation-delay: -0.45s;
  }

  div:nth-child(2) {
    animation-delay: -0.3s;
  }

  div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes lds-outer {
    0% {
      opacity: 0;
    }

    10% {
      opacity: 0;
    }

    40% {
      opacity: 1;
    }

    70% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  ${isRelativeStyle}
  ${isSmallStyle}
  ${isFixedStyle}
  ${hasNoOffsetStyle}
`;
